import { onDomReady } from 'Shared/utils/dom-ready';

onDomReady(() => {
   const div = document.querySelector('#blurbsWidget');
   if (div) {
      new BlurbsWidget(div);
   }
});

class BlurbsWidget {
   active = true;
   index = 0;

   constructor(container, options = {}) {
      this.options = { autoscroll: true, ...options };

      this.container = container;
      this.navThumbs = this.container.querySelectorAll('.blurbNavThumbs');

      this.navThumbs.forEach(el => {
         el.addEventListener('mouseenter', () => {
            this.activate(el);
         });
      });

      if (this.options.autoscroll && this.navThumbs.length) {
         this.container.addEventListener('mouseenter', this.pause.bind(this));
         this.container.addEventListener('mouseleave', this.resume.bind(this));

         setInterval(() => this.rotate(), 6000);
      }
   }

   rotate() {
      if (!this.active) {
         return;
      }

      if (++this.index >= this.navThumbs.length) {
         this.index = 0;
      }

      this.activate(this.navThumbs[this.index]);
   }

   pause() {
      this.active = false;
   }

   resume() {
      this.active = true;
   }

   activate(el) {
      let index = el.id.split('_', 2)[1];

      this.container.querySelectorAll('.selectedBlurb').forEach(blurb => {
         blurb.classList.toggle('blurbHidden', blurb.id.split('_', 2)[1] != index);
      });

      // Remove border, add shading to inactives
      this.navThumbs.forEach(blurb => {
         blurb.querySelector('a').classList.remove('active');
      });

      // Add border, remove shading to the active element
      el.querySelector('a').classList.add('active');
   }
}
